import { atomWithImmer } from 'jotai-immer';

export interface CreateMapAtomPayload<T> {
    initialValue?: Record<string, T>;
    debugLabel?: string;
}
export function createMapAtom<T>(payload: CreateMapAtomPayload<T> = {}) {
    const { initialValue = {}, debugLabel = 'MapAtom' } = payload;
    const entitysAtom = atomWithImmer<Record<string, T>>(initialValue);
    entitysAtom.debugLabel = debugLabel;
    return entitysAtom;
}
